<template>
	<viewer :uri="uri" :embed="embedHtml" :viewType="viewerRbtn"></viewer>
</template>
<script>
	import { ref, inject, onMounted, computed } from "vue";
	import viewer from "@/components/webComponents/widget/viewer/viewer.vue";

	export default {
		components: {
			viewer
		},
		props: {
			uri: {
				type: String,
				default: ""
			},
			embed: {
				type: String,
				default: undefined
			},
			viewerRbtn: {
				type: String,
				default: "false"
			}
		},
		setup(props, context) {
			const $json = inject("$json");

			const embedHtml = ref(props.embed);

			if ($json.packed(props.embed)) {
				embedHtml.value = $json.unpack(props.embed);
			} else {
				embedHtml.value = props.embed || "";
			}

			return {
				embedHtml
			};
		}
	};
</script>
